import { TTranslateFunction } from '@modules/localization/types/TranslateFunction';
import { OpenAPI } from '@rbx/docsite-utilities/dist/browser';
import resolveReference from './resolveReference';

export default function getOneOfMarkdown(
  translate: TTranslateFunction,
  operation: OpenAPI.OperationObject,
  document: OpenAPI.Document,
): string {
  if (operation.requestBody === undefined) {
    return '';
  }

  let requestBody: OpenAPI.RequestBodyObject | undefined;
  if ('$ref' in operation.requestBody) {
    requestBody = resolveReference(document, operation.requestBody, 'requestBodies');
    if (requestBody === undefined) {
      return '';
    }
  } else {
    requestBody = operation.requestBody;
  }

  if (Object.keys(requestBody.content).length === 0) {
    return '';
  }

  // Assume first content type is sufficient for the check
  const firstContent = Object.values(requestBody.content)[0];

  if (firstContent.schema === undefined) {
    return '';
  }

  let schema: OpenAPI.SchemaObject | undefined;
  if ('$ref' in firstContent.schema) {
    schema = resolveReference(document, firstContent.schema, 'schemas');
    if (schema === undefined) {
      return '';
    }
  } else {
    schema = firstContent.schema;
  }

  // Assume oneOf is at the top level of the request body
  const oneOf = schema['x-oneOf'];
  if (oneOf === undefined) {
    return '';
  }

  return `${translate('Description.OneOfPlural')}\n\n${Object.keys(oneOf)
    .map(
      (key: string) =>
        `- ${key}: ${(oneOf as Record<string, string[]>)[key].map((item: string) => `\`${item}\``).join(', ')}`,
    )
    .join('\n')}`;
}
